"use strict";

export default () => input => {
  const maxLength = 30;
  if (input && input.length > maxLength) {
    input = input.slice(0, maxLength) + "...";
  }
  return input;
};
